<template>
  <span class="">
    <el-button
      ref="btnPrint"
      class="btn"
      :class="options.addClass ? options.addClass : ''"
      :size="options.size ? options.size : 'small'"
      :type="options.btnType ? options.btnType : ''"
      :loading="keyBtn"
      @click.native="openMenu($event)"
      v-if="hasPower"
      :disabled="isDisabled"
      icon="iconfont icondayin"
    >
      <!-- <i class="iconfont icondayin" v-show="!options.isHideIcon?true:false"></i> -->
      {{ !options.hideTitle ? options.btnTitle : '' }}
    </el-button>
  </span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import printJS from 'print-js'
export default {
  name: 'Print',
  data() {
    return {
      versionMsg: '',
      keyBtn: false,
      hasLodop: false,
      hasBeforePrint: true,
      language: '',
      lodop: null, // 打印插件对象
      prinyValue: undefined // 获取打印机的index
    }
  },
  props: {
    getPrintData: Function,
    beforePrint: Function,
    typeName: {
      type: String,
      default: () => {
        return 'oneAndtwoLinkPage'
      } // 是否有一联两联面单，默认有
    },
    options: {
      type: Object,
      default: () => {
        return {
          btnTitle: this.$lang('打印'),
          btnType: ''
        }
      }
    },
    hasPower: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['langList']),
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    }
  },

  methods: {
    ...mapActions(['SET_USER', 'LOGIN_INIT', 'SET_SYSTEM_MENU']),

    async openMenu(e) {
      if (this.beforePrint && this.hasBeforePrint) {
        this.beforePrint()
        return
      }
      this.hasBeforePrint = true
      this.language = 'EN'
      this.toPrint()
    },
    // 选择面单后去打印
    async toPrint(value) {
      this.keyBtn = true
      this.$rightMenu.close()
      try {
        // const type = value && value === 'oneLinkPage' ? 1 : 2
        const type = this.userInfo.surfaceFormat
        const pdfBase = await this.getPrintData(type, this.language)
        // pdf 流文件 打印
        // console.log(pdfUrl, 'pdfUrl');
        // const reader = new FileReader()
        // reader.readAsDataURL(new Blob([pdfBase]))
        // reader.onload = async function () {
        //   const img = await reader.result.replace('data:application/octet-stream;base64,', '')
        //   console.log(img)
        //   printJS({
        //     printable: img,
        //     type: 'pdf',
        //     base64: true
        //   })
        // }
        pdfBase && window.open(pdfBase)
        this.keyBtn = false
      } catch (err) {
        this.keyBtn = false
      }
    }
  }
}
</script>
<style lang="scss"></style>
